import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
export var BoilerGroup;
(function (BoilerGroup) {
    BoilerGroup.get = createAccessors(arrayGetSet('boiler_groups'), {
        name: 'Группа котлов',
        lead_boiler_id: null,
        rotation_period: 1,
        setting_register: 0,
        slave_boiler_switch_delay: 10,
        boiler_list: [],
        timetables: [],
    });
    let BoilerGroupType;
    (function (BoilerGroupType) {
        BoilerGroupType[BoilerGroupType["CASCADE"] = 0] = "CASCADE";
        BoilerGroupType[BoilerGroupType["RESERVE"] = 1] = "RESERVE";
        BoilerGroupType[BoilerGroupType["PARALLEL"] = 2] = "PARALLEL";
        BoilerGroupType[BoilerGroupType["SCHEDULE"] = 3] = "SCHEDULE";
    })(BoilerGroupType = BoilerGroup.BoilerGroupType || (BoilerGroup.BoilerGroupType = {}));
    function getType(group) {
        return (group.setting_register & 0x3);
    }
    BoilerGroup.getType = getType;
    function setType(group, type) {
        return {
            ...group,
            setting_register: (group.setting_register & ~0x3) | type,
        };
    }
    BoilerGroup.setType = setType;
})(BoilerGroup || (BoilerGroup = {}));
